<template>
    <div>
      <v-btn icon color="red" @click="showDialog = true">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
  
      <v-dialog v-model="showDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">Confirm deletion</v-card-title>
          <v-card-text>
            Are you sure you want to delete this item?
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="showDialog = false">
              Cancel
            </v-btn>
            <v-btn color="red" text @click="deleteItem">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  

  
import app from '@/main'
// =========== IMPORT SERVICES =============
import { CryptoService } from "@/services";

  export default {
    data() {
      return {
        showDialog: false,
       
      };
    },
    props: {
    rate: Object,
  },
    methods: {
      async deleteItem() {

        let data = await CryptoService.deleteCoinRate(this.rate);
        if (data) {
        this.loading = false;
        //alert('success');
       // this.closeModal();
       this.$emit('reload');
        app.$store.dispatch('toast', {
          message: 'coin rate deleted',
          variant: 'success'
        })
      
        this.showDialog = false;

      }
      },
    },
  };
  </script>